import type { StepProps } from '@/components/CreateCampaignDialog/createCampaignType'
import { FormField } from '@/components/MultiStepForm/FormField/FormField'
import styles from './CampaignInfoStep.module.css'

export const CampaignInfoStep = ({ data, updateData, errors }: StepProps) => {
  return (
    <div className={styles.Container}>
      <FormField label="Campaign Name" error={errors?.name}>
        <input
          type="text"
          placeholder="e.g., Summer Fashion Collection"
          value={data.name || ''}
          onChange={(e) => updateData({ name: e.target.value.replace(/[^\w\săĂâÂîÎțȚșȘ\-'"_.,@&!?:;]/g, '') })}
          className={styles.Input}
          minLength={1}
          maxLength={300}
        />
      </FormField>

      <FormField label="Product Name" error={errors?.product}>
        <input
          type="text"
          placeholder="e.g., Summer Fashion Collection"
          value={data.product || ''}
          onChange={(e) => updateData({ product: e.target.value.replace(/[^\wăĂâÂîÎțȚșȘ\s\-'"_.,!?:;]/g, '') })}
          className={styles.Input}
          minLength={1}
          maxLength={50}
        />
      </FormField>

      <FormField label="Content Format" error={errors?.contentFormat}>
        <input
          type="text"
          placeholder="Type Format"
          value={data.contentFormat || ''}
          onChange={(e) => updateData({ contentFormat: e.target.value.replace(/[^A-Za-zăĂâÂîÎțȚșȘ]/g, '') })}
          className={styles.Input}
        />
      </FormField>

      <FormField label="Description" error={errors?.description}>
        <textarea
          placeholder="Text"
          value={data.description || ''}
          onChange={(e) => updateData({ description: e.target.value })}
          className={styles.Textarea}
          rows={4}
          maxLength={2000}
          minLength={1}
        />
        <span className={styles.CharCount}>
          *The maximum number of symbols must be {data?.description ? data?.description.length : 0}/2000
        </span>
      </FormField>

      {/* <FormField label="End Date" error={errors?.endDate}>
        <div className={styles.DateInputWrapper}>
          <DateIcon size={20} color="var(--color-text-on-light-10)" className={styles.CalendarIcon} />
          <input
            type="date"
            value={data.endDate || ''}
            onChange={(e) => updateData({ endDate: e.target.value })}
            className={styles.DateInput}
          />
        </div>
      </FormField> */}
    </div>
  )
}
